<template>
  <div class="remote">
    <div
      class="control-wrap"
      v-if="$store.state.client == 'mac' || $store.state.client == 'windows'"
    >
      <div class="title">
        远程协助
        <div class="open-btn" :class="{ off: !isOpen }" @click="changeOpen">
          <div class="btn-icon"></div>
        </div>
      </div>
      <div class="sub-title">本机协助码</div>
      <div class="sub-value" v-if="isOpen">
        <div class="sub-value-id">{{ rustdeskID }}</div>
        <div
          class="copy-btn copy-class"
          :data-clipboard-text="rustdeskID"
          @click="copyClick"
        ></div>
      </div>
      <div class="sub-value" v-else>
        <div class="sub-value-id">本机已关闭远程协助</div>
        <div
          class="copy-btn copy-class"
          :data-clipboard-text="rustdeskID"
          @click="copyClick"
        ></div>
      </div>
      <div class="sub-title">验证码</div>
      <div class="sub-value">
        <div class="sub-password" v-if="isShow && isOpen">
          {{ rustdeskPassword }}
        </div>
        <div class="sub-password" v-else-if="!isOpen">------</div>
        <div class="sub-password" v-else>******</div>
        <div class="refresh-btn" @click="onRefreshClick"></div>
        <div
          class="show-btn"
          :class="{ off: !isShow }"
          @click="changeShow"
        ></div>
      </div>
      <div class="title title-bottom">发起远控</div>
      <div class="bottom-wrap">
        <input
          type="text"
          v-model="connectRustdeskID"
          placeholder="请输入远程设备协助码"
        />
        <div class="bottom-btn" @click="connectRustdesk">连接</div>
      </div>
    </div>
    <div class="download-wrap" v-else>
      <div class="title">远程协助</div>
      <div class="desc-img"></div>
      <div class="desc-text">轻松连接远程电脑</div>
      <div class="download-btn" @click="goDownload">下载客户端</div>
      <div class="system-wrap">
        <div class="system-item windows"></div>
        <div class="system-item mac">
          <div class="hot">即将上线</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
export default {
  data: function () {
    return {
      isOpen: false,
      isShow: false,
      rustdeskID: "",
      rustdeskPassword: "123",
      connectRustdeskID: "",
    };
  },
  methods: {
    closeRustdesk: function () {
      if (window.external && window.external.closeRustdesk) {
        window.external.closeRustdesk();
      }
    },
    openRustdesk: function () {
      if (window.external && window.external.openRustdesk) {
        window.external.openRustdesk();
      }
    },
    copyClick: function () {
      let _that = this;
      let clipboard = new Clipboard(".copy-class");
      _that.$store.state.toast = "复制成功";
      clipboard.on("success", (e) => {
        _that.$store.state.toast = "复制成功";
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        _that.$store.state.toast = "复制失败";
        clipboard.destroy();
      });
    },
    connectRustdesk: function () {
      let _that = this;
      if (!this.connectRustdeskID) {
        _that.$store.state.toast = "请输入远程设备协助码";
        return;
      }
      if (window.external && window.external.getRustdesk) {
        window.external.getRustdesk("--connect " + this.connectRustdeskID);
      }
    },
    getRustdeskID: function () {
      if (window.external && window.external.getRustdeskResult) {
        this.rustdeskID = window.external.getRustdeskResult("--get-id");
      }
    },
    onRefreshClick: function () {
      if (!this.isOpen) {
        return;
      }
      this.refreshPassword();
    },
    refreshPassword: function () {
      if (window.external && window.external.getRustdeskResult) {
        this.rustdeskPassword = window.external.getRustdeskResult(
          "--update-tmp-password"
        );
      }
      this.getPassword();
    },
    getPassword: function () {
      if (window.external && window.external.getRustdeskResult) {
        this.rustdeskPassword =
          window.external.getRustdeskResult("--get-tmp-password");
      }
    },
    changeOpen: function () {
      let _that = this;
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.openRustdesk();
        // this.refreshPassword();
        setTimeout(() => {
          _that.getPassword();
        }, 1000);
      } else {
        this.closeRustdesk();
      }
      if (!this.isOpen) {
        this.isShow = false;
      }
    },
    changeShow: function () {
      if (!this.isOpen) {
        return;
      }
      this.isShow = !this.isShow;
      if (this.isShow) {
        _that.getPassword();
      }
    },
    goDownload: function () {
      let _that = this;
      _that.$router.push("/home/download");
    },
  },
  mounted: function () {
    this.getRustdeskID();
    this.getPassword();
  },
};
</script>

<style lang="less" scoped>
.remote {
  position: absolute;
  width: 288px;
  height: 348px;
  border-radius: 8px;
  border: 1px solid #e0e6f3;
  background: #f5f8ff;
  z-index: 3;
  right: 20px;
  top: 14px;
  .download-wrap {
    .title {
      color: var(--H1-1F1F1F, #1f1f1f);
      font-family: PingFang SC;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-top: 28px;
      margin-left: 24px;
    }
    .desc-img {
      width: 153px;
      height: 99px;
      background-image: url(../../assets/components/node/remotecontrol/desc-icon.png);
      background-size: 100% 100%;
      background-position: center center;
      margin: 0 auto;
      margin-top: 25px;
    }
    .desc-text {
      margin-top: 0px;
      color: var(--H2, #4a4a4a);
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-align: center;
    }
    .download-btn {
      width: 156px;
      height: 42px;
      flex-shrink: 0;
      border-radius: 200px;
      background: linear-gradient(
        196deg,
        #6c69fe -2.77%,
        #4c49ec 29.86%,
        #29439d 87.32%
      );
      box-shadow: 0px -1.7px 3.4px 0px rgba(35, 72, 106, 0.21) inset;

      color: #fff;
      text-align: center;
      font-family: PingFang SC;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 42px;

      margin: 0 auto;
      margin-top: 28px;
    }
    .download-btn:hover {
      cursor: pointer;
      opacity: 0.9;
    }
    .system-wrap {
      text-align: center;
      padding-top: 10px;
      margin: 0 auto;
      margin-top: 20px;
      border-top: 1px dashed #dfe3eb;
      width: 240px;
      .system-item {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        display: inline-block;
        vertical-align: top;
        background-image: url(../../assets/components/node/remotecontrol/windows.png);
        background-size: 100% 100%;
        background-position: center center;
        position: relative;
        .hot {
          background-image: linear-gradient(180deg, #ff8329 0%, #ff2db7 100%);
          position: absolute;
          right: -66px;
          top: -6px;
          width: 66px;
          color: #fff;
          font-size: 12px;
          font-weight: 600;
          height: 22px;
          line-height: 22px;
          border-radius: 8px;
          border-bottom-left-radius: 0;
        }
      }
      .mac {
        background-image: url(../../assets/components/node/remotecontrol/mac.png);
        margin-left: 50px;
      }
    }
  }
  .control-wrap {
    .title.title-bottom {
      border-top: 1px dashed #dfe3eb;
      padding-top: 20px;
      margin-top: 20px;
      width: 235px;
    }
    .title {
      color: var(--H1-1F1F1F, #1f1f1f);
      font-family: PingFang SC;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-top: 25px;
      margin-left: 24px;
      height: 30px;
      line-height: 30px;
      .open-btn {
        float: right;
        width: 46px;
        height: 24px;
        background-color: #07c160;
        border-radius: 12px;
        margin-right: 24px;

        .btn-icon {
          width: 20px;
          height: 20px;
          border-radius: 10px;
          background-color: #ffffff;
          margin-top: 2px;
          margin-right: 2px;
          float: right;
        }
      }
      .open-btn:hover {
        cursor: pointer;
        opacity: 0.9;
      }
      .open-btn.off {
        background-color: #c2c2c2;
        .btn-icon {
          float: left;
          margin-left: 2px;
        }
      }
    }
    .sub-title {
      color: var(--H2-4A4A4A, #4a4a4a);
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-top: 16px;
      margin-left: 24px;
      height: 22px;
      line-height: 22px;
    }
    .sub-value {
      color: #3b38c0;
      font-family: PingFang SC;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-top: 4px;
      margin-left: 24px;
      height: 30px;
      line-height: 30px;
      .sub-password {
        float: left;
      }
      .refresh-btn {
        width: 20px;
        height: 20px;
        background-image: url(../../assets/components/node/remotecontrol/refresh.svg);
        background-size: 100% 100%;
        background-position: center center;
        float: right;
        margin-right: 28px;
        margin-top: 4px;
      }
      .show-btn {
        width: 20px;
        height: 20px;
        background-image: url(../../assets/components/node/remotecontrol/eye_on.svg);
        background-size: 100% 100%;
        background-position: center center;
        float: right;
        margin-right: 16px;
        margin-top: 5px;
      }
      .show-btn.off {
        background-image: url(../../assets/components/node/remotecontrol/eye_off.svg);
      }
      .refresh-btn:hover {
        cursor: pointer;
        opacity: 0.9;
      }
      .show-btn:hover {
        cursor: pointer;
        opacity: 0.9;
      }
      .sub-value-id {
        float: left;
      }
      .copy-btn {
        width: 20px;
        height: 20px;
        background-image: url(../../assets/components/node/remotecontrol/copy.svg);
        background-size: 100% 100%;
        background-position: center center;
        float: right;
        margin-right: 28px;
        margin-top: 4px;
      }
      .copy-btn:hover {
        cursor: pointer;
        opacity: 0.9;
      }
    }
    .bottom-wrap {
      width: 240px;
      height: 42px;
      border-radius: 24px;
      border: 0.5px solid #d8e0f0;
      background: #fff;
      box-shadow: 0px 2px 4px 0px rgba(42, 47, 90, 0.08);
      margin: 0 auto;
      margin-top: 12px;
      overflow: hidden;
      input {
        height: 42px;
        line-height: 42px;
        font-size: 14px;
        margin-left: 15px;
        color: #666666;
      }
      .bottom-btn {
        width: 68px;
        height: 42px;
        flex-shrink: 0;
        border-radius: 0px 24px 24px 0px;
        background: #3b38c0;
        color: #fff;
        text-align: center;
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 42px;
        float: right;
      }
      .bottom-btn:hover {
        cursor: pointer;
        opacity: 0.9;
      }
    }
  }
}
</style>